module.exports = __webpack_public_path__ + "static/18-e390f5c678499e7ddcf3b7886c4bece2.jpg";